import { combineReducers } from 'redux';
import { GenericAction, genericReducer, GenericState } from 'services/genericAPIGatewayService';
import { Brand, Group, Site } from '../entities';
import { Sagas as BrandsSagas } from './brands';
import { Sagas as GroupsSagas } from './groups';
import { moveListener } from './sagas/moveSaga';
import { prioritiseNewCampaign } from './sagas/prioritiseNewCampaignSaga';
import { pushbackOnInvalidClientId } from './sagas/redirectSaga';
import { wizardCreationListener } from './sagas/wizardSaga';
import { Service } from './services';
import { Sagas as SitesSagas } from './sites';
import { Action as MoveAction, reducer as moveReducer, State as MoveState } from './state/moveState';
import { Action as WizardAction, reducer as wizardReducer, State as WizardState } from './state/wizardState';

export { Service };

export type Action =
  | GenericAction<Brand, Service.Brands>
  | GenericAction<Group, Service.Groups>
  | GenericAction<Site, Service.Sites>
  | WizardAction
  | MoveAction;

export interface State {
  brands: GenericState<Brand>;
  groups: GenericState<Group>;
  sites: GenericState<Site>;
  wizard: WizardState;
  move: MoveState;
}

export const reducer = combineReducers<State>({
  brands: genericReducer<Brand, Service.Brands>(Service.Brands),
  groups: genericReducer<Group, Service.Groups>(Service.Groups),
  sites: genericReducer<Site, Service.Sites>(Service.Sites),
  wizard: wizardReducer,
  move: moveReducer,
});

export const Sagas = [
  ...BrandsSagas,
  ...GroupsSagas,
  ...SitesSagas,
  pushbackOnInvalidClientId,
  prioritiseNewCampaign,
  wizardCreationListener,
  moveListener,
];
